
// Base.
import Component from 'vue-class-component'
import Vue from 'vue'
import { State } from 'vuex-class'
import { INotificationService } from '../services/NotificationService'
import ErrorHandler from '@/services/ErrorHandlerService'
// Used to call service.
import PermissionService from '../services/permissionService'

// Used Models.
import GridHeader from '../models/gridHeader'
import Permission, { Category } from '../models/permission'

// Used Components
import CardTable from '../components/Layout/CardTable.vue'
import GreenButton from '../components/Atomic/GreenButton.vue'
import CardTitle from '../components/Atomic/CardTitle.vue'
import HelpTooltip from '../components/Atomic/HelpTooltip.vue'
import SearchField from '@/components/Atomic/SearchField.vue'
import { Watch } from 'vue-property-decorator'
import ToolTipButton from '@/components/Atomic/ToolTipButton.vue'

@Component({
  components: {
    ToolTipButton,
    CardTable,
    GreenButton,
    HelpTooltip,
    CardTitle,
    SearchField,
  },
})
export default class Perm extends Vue {
  @State
  private user!: any
  // Data properties.
  private permissions: Permission[] = []
  private filteredPermissions: Permission[] = []
  private categories: Category[] = []
  private search: string = ''
  // private permissionsToUpdate: Set<Permission> = new Set()
  private permissionsToUpdate = new Set<Permission>()
  private $notificationService!: INotificationService
  private errorHandler = new ErrorHandler()
  // UI properties.
  private headers: GridHeader[] = []
  private isPending: boolean = false

  constructor() {
    super()
  }

  public mounted() {
    this.initialize()
  }

  private initialize() {
    this.fetchPermissionAndCategories()
    this.createHeaders()
  }

  @Watch('search')
  private filterPermissions() {
    this.filteredPermissions = this.permissions.filter((permission) => {
      if (!this.search) {
        return true
      }
      if (
        (this.$t(`ROLE.${permission.code_name}`) as string)
          .toLowerCase()
          .includes(this.search.toLowerCase())
      ) {
        return true
      }
    })
  }

  private async fetchPermissionAndCategories() {
    this.permissions = await PermissionService.get()
    this.filteredPermissions = this.permissions
    this.categories = await PermissionService.getPermissionsCategories()
  }

  private createHeaders() {
    this.headers.push(
      new GridHeader(this.$t('PERMISSIONS.Category').toString(), 'category'),
    )
    this.headers.push(
      new GridHeader(this.$t('PERMISSIONS.Name').toString(), 'code_name'),
    )
    this.headers.push(
      new GridHeader(this.$t('PERMISSIONS.Protected').toString(), 'protected'),
    )
  }

  private async save() {
    this.isPending = true
    try {
      if (this.permissionsToUpdate.size > 0) {
        await PermissionService.updatePermissions(this.permissionsToUpdate)
        this.$notificationService.success(
          this.$t('PERMISSIONS.Updated').toString(),
        )
      } else {
        this.$notificationService.success(
          this.$t('PERMISSIONS.NothingToUpdate').toString(),
        )
      }
    } catch (error: any) {
      this.errorHandler.handle(this, error.response.data.code, true)
    } finally {
      this.fetchPermissionAndCategories()
    }
    this.isPending = false
  }
}
